import './HeroSection.css';
import policyHeader from "../images/policyHeader.svg"

const Policy = () => (
  <section className="policy-section scroll-fx-up-out-fade scroll-fx-up-in">
    <div className="policy-header container-fluid text-center">
      <img
        className="img-fluid"
        src={policyHeader}
        alt="Policy Section Header Image"
      />
    </div>
    <div className="container">
      <div className="policy-plaque">
        <div className="policy-label">Official Minting Policy</div>
        <code>42b10fcf4d97eb7ba9a498a732be35d92a7ad91ac318f1210bc49834</code>
      </div>
      <p className="policy-legacy">
        Series One (2022, closed): d55224806767e38b7ca0b988104e38a6d31f190afc2fb6d5e700465c
      </p>
    </div>
  </section>
);

export default Policy;
